import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  platform?: 'youtube' | 'vimeo';
  title: string;
}

export const VideoModal: React.FC<VideoModalProps> = ({ isOpen, onClose, videoId, platform = 'vimeo', title }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
      document.body.style.overflow = 'hidden';
    } else {
      const timer = setTimeout(() => setShow(false), 500); // Wait for animation
      document.body.style.overflow = 'unset';
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!show && !isOpen) return null;

  let src = '';
  if (platform === 'vimeo') {
    // Native-looking Vimeo player: Remove all branding, controls customized
    src = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0&badge=0&vimeo_logo=0&transparent=1&dnt=1&controls=1&pip=1&quality=1080p&loop=0&muted=0`;
  } else {
    src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0&modestbranding=1`;
  }

  return (
    <div 
      className={`fixed inset-0 z-[100] flex items-center justify-center transition-all duration-500 ${
        isOpen ? 'bg-stone-900/90 backdrop-blur-md opacity-100' : 'bg-transparent opacity-0 pointer-events-none'
      }`}
      onClick={onClose}
    >
      <button 
        className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors transform hover:rotate-90 duration-300 z-[110]"
        onClick={onClose}
      >
        <X size={40} strokeWidth={1} />
      </button>

      <div 
        className={`w-full max-w-6xl aspect-video mx-6 relative bg-black shadow-2xl transition-all duration-700 delay-100 ${
          isOpen ? 'scale-100 translate-y-0 opacity-100' : 'scale-95 translate-y-12 opacity-0'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <iframe
          width="100%"
          height="100%"
          src={src}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        ></iframe>
      </div>
      
      <div className={`absolute bottom-10 left-0 w-full text-center text-white/80 font-serif text-2xl tracking-wide transition-all duration-700 delay-300 ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        {title}
      </div>
    </div>
  );
};